const productFragment = /* GraphQL */ `
  fragment product on Product {
    id
    handle
    title
    description
    descriptionHtml
    tracksInventory
    totalInventory
    servingsPerContainer: metafield(key: "servings_per_container", namespace: "custom") {
      value
    }
    originalPrice: metafield(key: "original_price", namespace: "custom") {
      value
    }
  }
`;

const variantFragment = /* GraphQL */ `
  fragment variant on ProductVariant {
    id
    title
    availableForSale
    inventoryPolicy
    contextualPricing(context: { country: $countryCode }) {
      price {
        amount
      }
    }
    product {
      ...product
    }
  }
  ${productFragment}
`;

export default variantFragment;
